import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Framework } from '@flint/framework';
import { inject, observer } from "mobx-react";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),
    },
    paper: {
        width: '100%',
        height: "100%",
    },
    formTextField: {
        margin: theme.spacing(2, 0),
    },
    formControl: {
        width: "100%",
        margin: theme.spacing(2, 0),
    },
    formControlLabel: {
        margin: (theme.spacing(2)),
        marginBottom: 0,
        "&:nth-child(1)": {
            marginLeft: 0,
        }
    },
    formButton: {
        color: "#FFF",
        padding: "15px",
        margin: theme.spacing(2, 0),
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "uppercase",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
    },
    formTitle: {
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    }
}));

const AddGenusSpeciality=({ AddGenusSpecialityStore, AddGenusSpecialityStoreStatus })=>{
    const classes = useStyles();
    
    const [type, setType] = React.useState('');
    const handleType = (e) => {
        setType(e.target.value);
    };

    const [name, setName] = React.useState('');
    const handleName =  (e) => {
        setName(e.target.value);
    }


    const [btnText, setBtnText] = useState('Add');
    const [btnStyle, setBtnStyle] = useState({});

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setBtnText("Submit");
        setBtnStyle({});
        setType('');
        setName('');
    };
 
    const handleGoToHome = () => {
        Framework.redirect(`/`);
    }

    const submitChoice = (e) => {
        e.preventDefault();
       
        if (type.length === 0) {
            alert("Please select a type");
        } else if (name.length === 0) {
            alert("Please enter something");
        } else {
            setBtnStyle({
                "pointerEvents": "none",
                "opacity": "0.5",
            })
            const classification =  {key:type, value:name};
            setBtnText('Uploading...');
            AddGenusSpecialityStore.fetch(classification);
            setOpen(true);
            AddGenusSpecialityStore.reset();
        }
    }

    return(
        
        <>
        {AddGenusSpecialityStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Add Genus / Speciality</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AddGenusSpecialityStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Add More
                    </Button>
                    <Button onClick={handleGoToHome} color="primary">
                        Go To Home
                    </Button>
                </DialogActions>
            </Dialog>}
        <div className={classes.root}>
                <Grid container spacing={3} justify="center">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Paper className={classes.paper}>
                            <form className={classes.root}>
                                <Typography className={classes.formTitle} variant="h1" id="tableTitle" component="div">Add Genus / Speciality</Typography>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel htmlFor="Select Type">Select Type</InputLabel>
                                    <Select label="Select Type" hidden id="type" value={type} name="Select Type" onChange={handleType}>
                                            {/* <MenuItem key="Select Type" value="Select Type">
                                                Select Type
                                            </MenuItem> */}
                                            <MenuItem key="genus" value="genus">
                                                Genus
                                            </MenuItem>
                                            <MenuItem key="specialty" value="specialty">
                                                Speciality
                                            </MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField className={classes.formTextField} id="name" label="Name" value={name} onChange={handleName} variant="outlined" fullWidth />
                                <Box display="flex" justifyContent="flex-end">
                                    <Button className={classes.formButton} variant="contained" color="primary" style={btnStyle}
                                    startIcon={<AddBoxIcon />} onClick={submitChoice}>{btnText}</Button>
                                </Box>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
            </>
    )
}

export default inject('AddGenusSpecialityStore', 'AddGenusSpecialityStoreStatus')(observer(AddGenusSpeciality));